import script from "./SelectArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectArea.vue?vue&type=script&lang=ts&setup=true"

import "./SelectArea.vue?vue&type=style&index=0&id=524f2c5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524f2c5b"]])

export default __exports__